import { render, staticRenderFns } from "./tinymce.vue?vue&type=template&id=87a579de&scoped=true&"
import script from "./tinymce.vue?vue&type=script&lang=ts&"
export * from "./tinymce.vue?vue&type=script&lang=ts&"
import style0 from "./tinymce.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./tinymce.vue?vue&type=style&index=1&id=87a579de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a579de",
  null
  
)

export default component.exports